import React__default, { useRef, useState, useEffect } from 'react';
import { usePopper } from 'react-popper';
import { Body } from '../Typography/index.es.js';
import { TooltipWrapper, StyledArrow } from './style.es.js';
import { getArrowClassName } from './utils.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Tooltip = (_a) => {
  var _b = _a, {
    children,
    placement = "auto",
    title,
    triggerHover = true,
    show,
    backgroundColor,
    textColor,
    style,
    timeDelay = 500
  } = _b, rest = __objRest(_b, [
    "children",
    "placement",
    "title",
    "triggerHover",
    "show",
    "backgroundColor",
    "textColor",
    "style",
    "timeDelay"
  ]);
  const elementRef = useRef(null);
  const tooltipRef = useRef(null);
  const arrowRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const timerRef = useRef(null);
  const { styles, attributes } = usePopper(elementRef.current, tooltipRef.current, {
    placement,
    modifiers: [
      {
        name: "arrow",
        options: { element: arrowRef.current }
      },
      {
        name: "offset",
        options: {
          offset: [0, 8]
        }
      }
    ]
  });
  const actionHover = triggerHover ? {
    onMouseEnter: () => timerRef.current = setTimeout(() => setVisible(true), timeDelay),
    onMouseLeave: () => {
      timerRef.current && clearTimeout(timerRef.current);
      setVisible(false);
    }
  } : {};
  useEffect(() => {
    if (!triggerHover) {
      setVisible(!!show);
    }
  }, [show]);
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);
  return /* @__PURE__ */ React__default.createElement("span", __spreadValues({}, actionHover), /* @__PURE__ */ React__default.createElement("span", {
    style: { display: "flex" },
    ref: elementRef
  }, children), /* @__PURE__ */ React__default.createElement(TooltipWrapper, __spreadValues(__spreadValues({
    ref: tooltipRef,
    style: __spreadValues(__spreadProps(__spreadValues({}, styles.popper), {
      visibility: visible ? "visible" : "hidden",
      zIndex: 999
    }), style),
    backgroundColor
  }, attributes.popper), rest), /* @__PURE__ */ React__default.createElement(StyledArrow, {
    ref: arrowRef,
    style: __spreadValues({}, styles.arrow),
    backgroundColor,
    className: getArrowClassName(attributes) || "",
    "data-placement": placement
  }), typeof title === "string" ? /* @__PURE__ */ React__default.createElement(Body, {
    level: 1,
    weight: "regular",
    color: textColor || "white"
  }, title) : React__default.cloneElement(title, {
    style: __spreadValues({ color: textColor || "white" }, title == null ? void 0 : title.props)
  })));
};

export { Tooltip };
